module.exports = __webpack_public_path__ + "img/mental1.962a3696.png";